import React, { useState } from 'react'
import { useMediaContext } from 'context/MediaContext'

import { Box, Grid } from '@mui/material'

import { Report } from 'model/Report'
import { Game, GamePlayer } from 'model/Game'
import { Chat } from 'model/Chat'

import Alerts from 'component/Game/Alerts'
import MatchingUser from 'component/Game/MatchingUser'
import Recorder from 'component/Game/Recorder'
import ReportDialog from 'component/Game/ReportDialog'

type Props = {
  user: GamePlayer
  game: Game,
  report: Report,
  chat: Chat
}
export default function GameRegister(props: Props) {
  const user = props.user
  const opponent = user.uuid === props.game.host.uuid ? props.game.guest : props.game.host
  const { isPc } = useMediaContext()

  const [reportedEmpty, setReportedEmpty] = useState(false)
  const [reportedByLoser, setReportedByLoser] = useState(false)
  const [isNotMatchFormat, setIsNotMatchFormat] = useState(false)

  return (
    <>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Alerts
          user={user}
          opponent={opponent}
          game={props.game}
          report={props.report}
          chat={props.chat}
          reportedEmpty={reportedEmpty}
          reportedByLoser={reportedByLoser}
          isNotMatchFormat={isNotMatchFormat}
        />

        <Grid container sx={isPc ? { mb: 4 } : { mt: 1, mb: 2 }}>
          <Grid item xs={6} display='flex' justifyContent='center'>
            <MatchingUser
              user={user}
              deckType={user.deck_type}
              media={{ isPc: isPc }}
              game={props.game}
            />
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='center'>
            <MatchingUser
              user={opponent}
              deckType={props.game.winner ? opponent.deck_type : undefined}
              media={{ isPc: isPc }}
              game={props.game}
            />
          </Grid>
        </Grid>

        <Recorder
          format={props.game.format}
          user={user}
          media={{ isPc: isPc }}
          game={props.game}
          report={props.report}
          setReportedEmpty={setReportedEmpty}
          setReportedByLoser={setReportedByLoser}
          setIsNotMatchFormat={setIsNotMatchFormat}
        />
      </Box>

      <ReportDialog
        user={user}
        opponent={opponent}
        media={{isPc: isPc}}
        report={props.report}
      />
    </>
  )
}